module.exports = __webpack_public_path__ + "img/step3.4c2961f0.png";